<template>
    <v-btn
      x-small
      v-clipboard:copy="tocopy"
      v-clipboard:success="onCopy"
      v-clipboard:error="onCopyError"
    > {{txt}}
      <v-icon right>{{icon}}</v-icon>
    </v-btn>
</template>

<script>
export default {
  name: "CopyBtn",
  props: {
    tocopy: {
      type: String
    }
  },
  data() {
    return {
      txt: 'Copy',
      failed: false,
      icon: 'fa-copy'
    }
  },
  methods: {
    onCopy() {
      // alert('You just copied: ' + e.text)
      //alert("Copied");
      this.icon = 'fa-check';
      this.txt = 'Copied';
    },
    onCopyError() {
      //alert("Failed to copy");
      this.icon = 'fa-exclamation-triangle';
      this.txt = 'Copy failed';
    }
  }
};
</script>

 